export const setProperty = (...fields) => (...values) => (object) => {
    for (let i = 0; i < fields.length; i++) {
        object[fields[i]] = values[i];
    }
};
